import makeCrudModule from '@/factories/CrudModelFactory';
import credentialsService from '@/services/deployment_credentials';

export default makeCrudModule({
    service: credentialsService,
    dateConvert: [
        'created_at', 'updated_at'
    ]
});
